<template>
  <div class="filtersPopup" :class="{ 'filtersPopup--open': isOpen }">
    <div class="filtersPopup__title">
      {{ title }}
      <button class="filtersPopup__close" @click="close"><span class="icon-line-close" /></button>
    </div>
    <div
      :class="[
        'filtersPopup__content',
        disableContentPadding ? 'filtersPopup__content--noPadding' : '',
      ]"
    >
      <slot name="content" />
    </div>
    <div class="filtersPopup__footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FiltersPopup',
  props: {
    title: {
      type: String,
      default: '',
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    disableContentPadding: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
.filtersPopup {
  $root: &;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  z-index: $zPopup;
  height: 100%;
  overflow: auto;
  transform: translateX(-100%);
  background-color: $cWhite;
  transition: transform $tr;

  &--open {
    transform: translateX(0%);
  }

  &__title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2rem;
    font-size: 1.6rem;
    line-height: 2rem;
    font-weight: 600;
    border-bottom: 1px solid $cAddLight;
    color: $cMainDark;

    @include rwd('large-tablet') {
      font-size: 1.8rem;
      line-height: 2.2rem;
      padding: 1.8rem 2rem;
    }
  }

  &__close {
    display: block;
    color: $cMain;
  }

  &__content {
    padding: 2rem 2rem 3rem 2rem;

    &--noPadding {
      padding: 0;
    }
  }

  &__footer {
    display: flex;
    margin-top: auto;
    padding: 2rem;
    background-color: rgba($cAddNeutral, 0.1);
  }
}
</style>
